
export default {
    url: '',
    template: '<forms-forms-list company-users="vm.companyUsers" form-categories="vm.formCategories" sites="vm.sites"/>',
    resolve: {
        companyUsers (UserResource) {
            return UserResource.query({ pageSize: 0, formAuthors: true }).$promise;
        },
        formCategories (FormCategoryResource) {
            return FormCategoryResource.tree().$promise;
        },
        sites (SiteResource) {
            return SiteResource.query({ formSites: true }).$promise;
        }
    },
    controller (companyUsers, formCategories, sites) {
        this.companyUsers = companyUsers;
        this.formCategories = formCategories;
        this.sites = sites;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/forms/list/index.js